import getToggleData from './get-toggle-data';
import getPlanLabel from './get-plan-label';
import getHighlightedPlanType from './get-hightlighted-plan-type';

import {
  getDomainPromoCaptions,
  getAnnualDiscountCaptions,
  getFooterCaptions,
  getLabelCaptions,
  getCollapseCaptions,
  getExtraPriceInfoTooltip,
} from './get-captions';

export default {
  getDomainPromoCaptions,
  getAnnualDiscountCaptions,
  getFooterCaptions,
  getLabelCaptions,
  getCollapseCaptions,
  getToggleData,
  getPlanLabel,
  getHighlightedPlanType,
  getExtraPriceInfoTooltip,
};
